import React from 'react';
import {WingBlank, Cols} from '../../components';
import Link from 'react-router/lib/Link';
import './Product.less';

function ProductCard({data: {title, description, img, to}}) {
  return (
    <Link className='ProductCard' to={to}>
      <div>
        <div>
          <img src={img} alt='image' />
        </div>
        <div>
          <h2>{title}</h2>
          <div>{description}</div>
        </div>
      </div>
    </Link>
  );
}

function Product(props) {
  return (
    <WingBlank className='Product'>
      <img src='/imgs/home/product_hot.png' alt='image'/>
      <Cols {...props}>
        <ProductCard />
      </Cols>
    </WingBlank>
  );
}

export default Product;


// WEBPACK FOOTER //
// ./src/routes/Home/Product.js